import axios from "axios";

export default {
  data() {
    return {
      boletaLinks: {
        afiliado: null,
        proveedor: null,
      },

      URLMapa: "",
      detalles: {},
      telefonoSMSCliente: "",
      nAsistencia: "",
      DatosCliente: "",
      poliza: "",
      tipoAsistencia: "",
      linkBoletaCliente: "",
      tecnicoAsignado: "",
    };
  },
  methods: {
    setNumeroAsistencia(numAsistencia) {
      this.nAsistencia = numAsistencia;
    },
    MensajeSMSCliente() {
      const linkBase = process.env.VUE_APP_AXIOS;

      let complementoConexion = "";
      if (this.detalles.tipoServicio === "CONEXION") {
        let link = `${linkBase}/ServicioConexion/${this.nAsistencia}`;
        complementoConexion =
          "\n" +
          "Por favor, ingrese al siguiente enlace 👇 y complete la información necesaria para continuar con su servicio:\n\n" +
          link;
      }

      if (this.boletaLinks.afiliado) {
        this.linkBoletaCliente = `${linkBase}/Boleta/${this.nAsistencia}?c=${this.boletaLinks.afiliado}`;
      } else {
        this.linkBoletaCliente = "";
      }

      let mensajeLinkCliente =
        "\n" +
        "Ayúdenos a seguir mejorando. Por favor, cuando el servicio haya finalizado, ingrese al siguiente link 👇 y complete la boleta electrónica.\n\n" +
        this.linkBoletaCliente;

      let textoCliente =
        this.linkBoletaCliente !== "" ? mensajeLinkCliente : "";

      this.DatosCliente =
        "Estimado(a):" +
        "\n" +
        "Se le notifica que su servicio de " +
        this.tipoAsistencia +
        ", bajo la póliza " +
        this.poliza +
        ", será atendido por " +
        this.tecnicoAsignado +
        ". \n" +
        "Estamos atentos a su servicio" +
        "\n" +
        this.URLMapa +
        textoCliente +
        complementoConexion;

      return this.DatosCliente;
    },
    buscarNumeroAsistencia(token) {
      let header = { Authorization: "Bearer " + token };
      let configuracion = { headers: header };
      axios
        .get(
          "api/Cabinas/MostrarCodigoNumAsistencia/" + this.nAsistencia,
          configuracion,
        )
        .then((response) => {
          this.detalles = response.data;
          this.agregarDetalle(response.data);
          this.getBoletaLinks();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    agregarDetalle(data = []) {
      this.poliza = data["poliza"];
      this.tipoAsistencia = data["tipoAsistencia"];
      this.tecnicoAsignado = data["proveedor"];
    },
    getBoletaLinks() {
      this.boletaLinks = {
        afiliado: null,
        proveedor: null,
      };

      axios
        .get(`api/FormularioFirma/${this.nAsistencia}/Links`)
        .then((res) => (this.boletaLinks = res.data))
        .catch((err) => console.log(err));
    },
  },
};
